import model from './model';
import SmartLockDetailsPage from './pages/SmartLockDetailsPage';

model.routes.setRoutes({
  detailsRoute: {
    component: SmartLockDetailsPage,
  },
});
